<ng-container *ngIf="isRecord(); else assetArray">
  <div class="p-grid">
    <div class="p-col-12">
      <div class="image-label">{{ field.label }}</div>
      <div class="image-details">
        <strong>Name:</strong>
        <span
          *ngIf="record[field.key]?.name || record[field.key]?.id"
          class="copyable-text"
          pTooltip="Click to copy: Name, ID, filename"
          tooltipPosition="top"
          (click)="copyAssetInfo(record[field.key])"
        >{{ record[field.key]?.name || 'Not Available' }}
          <a href="/miscellaneous-build/{{ record[field.key]?.id || '' }}" target="_blank" [ngStyle]="{ color: 'var(--primary-color)' }" (click)="$event.stopPropagation()">({{ record[field.key]?.id || 'Not Available' }})</a>
        </span>
        <ng-container *ngIf="!(record[field.key]?.name || record[field.key]?.id)">{{ record[field.key]?.name || 'Not Available' }}
          <a href="/miscellaneous-build/{{ record[field.key]?.id || '' }}" target="_blank" [ngStyle]="{ color: 'var(--primary-color)' }">({{ record[field.key]?.id || 'Not Available' }})</a>
        </ng-container>
      </div>
      <div class="image-details">
        <strong>Path:</strong>
        <span
          *ngIf="record[field.key]?.path"
          class="copyable-text"
          pTooltip="Click to copy path"
          tooltipPosition="top"
          (click)="copyPath(record[field.key])"
        >{{ record[field.key]?.path }}</span>
        <ng-container *ngIf="!record[field.key]?.path">{{ record[field.key]?.path || 'Not Available' }}</ng-container>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #assetArray>
  <div *ngIf="isArray()" class="array-container">
    <div *ngFor="let asset of record[field.key]; let i = index" class="array-item">
      <div class="image-label">{{ field.label }}</div>
      <div class="image-details">
        <strong>Name:</strong>
        <span
          *ngIf="asset?.name || asset?.id"
          class="copyable-text"
          pTooltip="Click to copy: Name, ID, filename"
          tooltipPosition="top"
          (click)="copyAssetInfo(asset)"
        >
          <a href="/miscellaneous-build/{{ asset?.id }}" target="_blank" (click)="$event.stopPropagation()">{{ asset?.name || 'Not Available' }}</a>
        </span>
        <ng-container *ngIf="!(asset?.name || asset?.id)">
          <a href="/miscellaneous-build/{{ asset?.id }}" target="_blank">{{ asset?.name || 'Not Available' }}</a>
        </ng-container>
      </div>
      <div class="image-details">
        <strong>Path:</strong>
        <span
          *ngIf="asset?.path"
          class="copyable-text"
          pTooltip="Click to copy path"
          tooltipPosition="top"
          (click)="copyPath(asset)"
        >{{ asset?.path }}</span>
        <ng-container *ngIf="!asset?.path">{{ asset?.path || 'Not Available' }}</ng-container>
      </div>
      <hr *ngIf="i < record[field.key].length - 1">
    </div>
  </div>
</ng-template>